exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1lvEWIMiV8KjS8fDuOXuQ8 .ms-Toggle-label{font-weight:400}", ""]);
// Exports
exports.locals = {
	"allDayToggle": "_1lvEWIMiV8KjS8fDuOXuQ8"
};